import { __rest } from "tslib";
import * as React from 'react';
import { CoreLinearProgressBar as CoreProgressBar } from '../internal/WixUiCoreComponents/components/CoreLinearProgressBar';
import { st, classes } from './ProgressBar.st.css';
/** ProgressBar component based on LinearProgressBar from wix-ui-core */
export class ProgressBar extends React.PureComponent {
    render() {
        const _a = this.props, { size, className } = _a, rest = __rest(_a, ["size", "className"]);
        return (React.createElement(CoreProgressBar, Object.assign({ className: st(classes.root, { size }, className) }, rest)));
    }
}
ProgressBar.displayName = 'ProgressBar';
ProgressBar.defaultProps = {
    value: 0,
    size: 'small',
};
//# sourceMappingURL=ProgressBar.js.map